<script lang="ts" setup>
const { $config } = useNuxtApp()
const route = useRoute()

if (isEmpty(useGetSubdomain()))
  navigateTo('', { redirectCode: 301 })

function updateMeta(newVal: any) {
  const robots = ($config.public.ENV === 'development' || $config.public.ENV === 'staging') ? { name: 'robots', content: 'nofollow, noindex' } : { name: 'robots', content: newVal.robots || 'nofollow, noindex' }
  useHead({
    title: newVal.title,
    meta: [
      { property: 'og:title', content: newVal.title },
      { name: 'twitter:title', content: newVal.title },
      { name: 'description', content: newVal.desc },
      { property: 'og:description', content: newVal.desc },
      { name: 'twitter:description', content: newVal.desc },
      { property: 'og:url', content: useSetSubdomain(useGetSubdomain()) + route.path },
      robots,
    ],
    link: [
      { rel: 'canonical', href: `${useSetSubdomain(useGetSubdomain())}${!isEmpty(newVal.canon) ? newVal.canon : route.path}` },
    ],
  })
}
</script>

<template>
  <BaseAtomsSkeletonBounded class="max-w-none text-gray-900 px-4 xl:px-0 pt-0 lg:pt-6 !pb-0">
    <SearchWithQuery v-if="!isEmpty(route.params.search) || !isEmpty(route.query)" @set-meta="metaVal => updateMeta(metaVal)" />
    <SearchEmptyQuery v-else @set-meta="metaVal => updateMeta(metaVal)" />
  </BaseAtomsSkeletonBounded>
</template>
